import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { PostsService } from '../../../services/posts.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { NgbActiveModal, NgbModal, ModalDismissReasons, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-post-list',
  templateUrl: './post-list.component.html',
  styleUrls: ['./post-list.component.scss']
})
export class PostListComponent implements OnInit {

    @Input() relatedTo: any;

    @Input() relatedId: any;

    @Input() isNewsFeed: any;

    @Input() isSinglePost: boolean = false;

    @Input() id: any;

    @Input() showCommentsOnly: boolean = false;

    


    posts: any[] = [];
    myContactLogo: string = "";
    userId: string = "";

    showLoading: boolean = true;

    constructor(private sanitizer: DomSanitizer, private route: ActivatedRoute,
        private router: Router, private postsService: PostsService,
        public authentication: AuthenticationService,
        private common: CommonService, private modalService: NgbModal) { }
    openCustomModal(content) {
        this.modalService.open(content, { size: 'lg' });
        
    }
    NextPage = 1;
    loadPosts() {
        this.showLoading = true;
        if (this.isNewsFeed == 'true')
            this.loadNewsFeedPosts(this.NextPage);
        else if (this.isSinglePost)
            this.loadSinglePost();
        else if (this.relatedTo == 'profile')
            this.loadUserPosts(this.NextPage);
        else
            this.loadModulePosts(this.NextPage);
    }
    
    ngOnInit(): void {
        
        this.loadPosts();
        this.myContactLogo = this.authentication.userData.contactLogo;
        this.userId = this.authentication._authentication.id;
    }


    loadSinglePost() {
        //getPostById
        this.postsService.getPostById(this.id, this.authentication._authentication.id).subscribe(
            (res: any) => {
                //console.log("res", res);
                if (res.success) {
                    res.data.createdDate = new Date(res.data.createdDate);
                    res.data.postRepliesCollapsed = true;
                    res.data.postContactLogo = res.data.fromPortalUser.contactLogo;
                    res.data.postReplies = this.prepareEditPanelAttribute(res.data);
                    res.data.commentsSummary = "view all comments (" + res.data.postReplies.length + ")";
                    res.data.shownComments = res.data.postReplies.length - 1;
                    res.data.reply = "";
                    res.data.rows = 1;
                    res.data.body = this.sanitizer.bypassSecurityTrustHtml(res.data.body);
                    this.posts.push(res.data);

                }
                else
                    console.error("getPostById(id, userId)", res.error_message);
            },
            (err: any) => {
                console.error("loadSinglePost():getPostById(id,userId)", err);
            }
        );
    }
    
    Size = 0;
    loadNewsFeedPosts(page: any) {
        this.postsService.getUserNewsFeedPosts(page, this.authentication._authentication.id).subscribe(
            (res: any) => {
                //console.log("res", res);
                if (res.success) {
                    for (var i = 0; i < res.data.length; i++) {
                        res.data[i].createdDate = new Date(res.data[i].createdDate);
                        res.data[i].postRepliesCollapsed = true;
                        res.data[i].postContactLogo = res.data[i].fromPortalUser.contactLogo;
                        res.data[i].postReplies = this.prepareEditPanelAttribute(res.data[i]);
                        res.data[i].commentsSummary = "view all comments (" + res.data[i].postReplies.length + ")";
                        res.data[i].shownComments = res.data[i].postReplies.length - 1;
                        res.data[i].reply = "";
                        res.data[i].rows = 1;
                        res.data[i].body = this.sanitizer.bypassSecurityTrustHtml(res.data[i].body);
                        this.posts.push(res.data[i]);
                        
                    }
                    this.NextPage = page + 1;
                    this.Size = this.Size + 1; 
                    //console.log("res " + page, res.data);
                    if (res.data.length > 0 && this.Size < 5)
                        this.loadNewsFeedPosts(this.NextPage);
                    else {
                        this.showLoading = false;
                        this.Size = 0;
                    }
                    
                }
                else
                    console.error("getUserNewsFeedPosts(page, userId)", res.error_message);
            },
            (err: any) => {
                console.error("loadPosts():getUserNewsFeedPosts(page,userId)", err);
            }
        );

    }
    loadUserPosts(page: any) {

        this.postsService.getUserPosts(page, this.authentication._authentication.id, this.relatedTo).subscribe(
            (res: any) => {
                //console.log("res", res);
                if (res.success) {
                    for (var i = 0; i < res.data.length; i++) {
                        res.data[i].createdDate = new Date(res.data[i].createdDate);
                        res.data[i].postRepliesCollapsed = true;
                        res.data[i].postContactLogo = res.data[i].fromPortalUser.contactLogo;
                        res.data[i].postReplies = this.prepareEditPanelAttribute(res.data[i]);
                        res.data[i].commentsSummary = "view all comments (" + res.data[i].postReplies.length + ")";
                        res.data[i].shownComments = res.data[i].postReplies.length - 1;
                        res.data[i].reply = "";
                        res.data[i].rows = 1;
                        res.data[i].body = this.sanitizer.bypassSecurityTrustHtml(res.data[i].body);
                        this.posts.push(res.data[i]);
                    }
                    this.NextPage = page + 1;
                    this.Size = this.Size + 1;
                    //console.log("res " + page, res.data);
                    if (res.data.length > 0 && this.Size < 5)
                        this.loadUserPosts(this.NextPage);
                    else {
                        this.showLoading = false;
                        this.Size = 0;
                    }

                    
                }
                else
                    console.error("getUserPosts(page,userId, relatedTo)", res.error_message);
            },
            (err: any) => {
                console.error("loadPosts():getUserPosts(page,userId, relatedTo)", err);
            }
        );
    }
    loadModulePosts(page: any) {

        this.postsService.getModulePosts(page, this.authentication._authentication.id, this.relatedTo, this.relatedId).subscribe(
            (res: any) => {
                //console.log("res", res);
                if (res.success) {
                    for (var i = 0; i < res.data.length; i++) {
                        res.data[i].createdDate = new Date(res.data[i].createdDate);
                        res.data[i].postRepliesCollapsed = true;
                        res.data[i].postContactLogo = res.data[i].fromPortalUser.contactLogo;
                        res.data[i].postReplies = this.prepareEditPanelAttribute(res.data[i]);
                        res.data[i].commentsSummary = "View all comments (" + res.data[i].postReplies.length + ")";
                        res.data[i].shownComments = res.data[i].postReplies.length - 1;
                        res.data[i].reply = "";
                        res.data[i].rows = 1;
                        res.data[i].body = this.sanitizer.bypassSecurityTrustHtml(res.data[i].body);
                        this.posts.push(res.data[i]);
                    }
                    this.NextPage = page + 1;
                    this.Size = this.Size + 1;
                    //console.log("res " + page, res.data);
                    if (res.data.length > 0 && this.Size < 5)
                        this.loadModulePosts(this.NextPage);
                    else {
                        this.showLoading = false;
                        this.Size = 0;
                    }

                }
                else
                    console.error("loadModulePosts(page,userId, relatedTo)", res.error_message);
            },
            (err: any) => {
                console.error("loadPosts():loadModulePosts(page,userId, relatedTo)", err);
            }
        );

    }
    prepareEditPanelAttribute(item: any) {
        var replies = [];
        item.replyLoading = false;
        for (var i = 0; i < item.postReplies.length; i++) {
            item.postReplies[i].createdDate = new Date(item.postReplies[i].createdDate);
            item.postReplies[i].showEditPanel = false;
            item.postReplies[i].user.contactLogo = item.postReplies[i].user.contactLogo;
            item.postReplies[i].rows = 1;
            //item.postReplies[i].createdDate = new Date(item.postReplies[i].createdDate);
            //if (!item.postReplies[i].isDeleted) {
            replies.push(item.postReplies[i]);
            //}
        }
        return replies;
    }

    openUserProfile(id: any) {
        this.router.navigate(['/profile/user-profile/' + id]);
    }
    openModule(relatedTo: any, relatedId: any) {
        if (relatedTo == "groups")
            this.router.navigate(['/groups/detail/' + relatedId]);
        else if (relatedTo == "articles")
            this.router.navigate(['/articles/detail/' + relatedId]);
        else if (relatedTo == "feedback")
            this.router.navigate(['/feedback/detail/' + relatedId]);
        else if (relatedTo == "request")
            this.router.navigate(['/request/detail/' + relatedId]);
        else if (relatedTo == "discussion")
            this.router.navigate(['/discussion/detail/' + relatedId]);
        else if (relatedTo == "support")
            this.router.navigate(['/support/support-case-details/' + relatedId]);
        else if (relatedTo == "profile")
            this.router.navigate(['/profile/user-profile/' + relatedId]);
        else if (relatedTo == "certificate")
            this.router.navigate(['/profile/certificates']);
        else if (relatedTo == "requests")
            this.router.navigate(['/request/detail/' + relatedId]);
    }

    openPost(item: any) {
        console.log("postItem", item);
        this.router.navigate(["/home/post/" + item.postId]);
    }

    sendPostReply(post: any, postIndex: any) {
        if (post.reply) {
            post.replyLoading = true;
            this.postsService.sendPostReply(post.reply, post.postId, this.authentication._authentication.id).subscribe(
                (res: any) => {
                    if (res.success) {
                        if (res.data != null) {
                            this.posts[postIndex].postRepliesCollapsed = false;
                            this.posts[postIndex].postContactLogo = res.data.fromPortalUser.contactLogo;
                            this.posts[postIndex].postReplies = this.prepareEditPanelAttribute(res.data);
                            this.posts[postIndex].commentsSummary = "view all comments (" + res.data.postReplies.length + ")";
                            this.posts[postIndex].shownComments = res.data.postReplies.length;
                            this.posts[postIndex].reply = "";
                            this.posts[postIndex].rows = 1;
                            this.posts[postIndex].body = this.sanitizer.bypassSecurityTrustHtml(res.data.body);
                            this.posts[postIndex].replyLoading = false;

                        }

                    }
                },
                (err: any) => {
                    post.replyLoading = false;
                    console.error("sendPostReply err", err);
                }
            );
        }
        else {
            this.common.ShowMessage("error", "reply is mandatory", "");
        }

    }

    onCommentKeyUp(evt: any, item: any) {

        item.rows = item.reply.split(/\r*\n/).length;
    }
    deleteReply(reply: any) {

        this.postsService.deletePostReply(reply).subscribe(
            (res: any) => {
                if (res.success) {

                    if (res.data != null) {
                        var postId = res.data.postId;

                        for (var i = 0; i < this.posts.length; i++) {
                            if (this.posts[i].postId == postId) {

                                this.posts[i].postRepliesCollapsed = false;
                                this.posts[i].postContactLogo = res.data.fromPortalUser.contactLogo;
                                this.posts[i].postReplies = this.prepareEditPanelAttribute(res.data);
                                this.posts[i].commentsSummary = "view all comments (" + res.data.postReplies.length + ")";
                                this.posts[i].shownComments = res.data.postReplies.length;
                                this.posts[i].body = this.sanitizer.bypassSecurityTrustHtml(res.data.body);
                                this.posts[i].reply = "";

                                break;
                            }
                        }
                    }

                }

            },
            (err: any) => {
                console.error("deleteReply", err)
            });

    }

    showEditReply(reply: any) {
        reply.showEditPanel = true;

    }
    editReply(reply: any) {
        var obj = {
            "replyId": reply.postReplyId,
            "reply": reply.body
        };

        this.postsService.updatePostReply(obj).subscribe(
            (res: any) => {
                if (res.success) {
                    reply.showEditPanel = false;
                    reply.isEdited = true;
                    reply.data = res;
                }
            },
            (err: any) => {
                console.error("editReply", err)
            });
    }
    cancelEditReply(reply: any) {
        reply.showEditPanel = false;
    }

    toggleReplies(post: any) {
        post.postRepliesCollapsed = !post.postRepliesCollapsed;
        post.commentsSummary = "View all comment(s) (" + post.postReplies.length + ")";
        if (!post.postRepliesCollapsed) {
            post.commentsSummary = "Hide comment(s)";
            post.shownComments = 0;
        }
        else
            post.shownComments = post.postReplies.length - 1;
    }

    openImagePreview(base64Image: any) {

        //let obj: any = {

        //  data: base64Image
        //};
        //let dialogRef = this.dialog.open(PostImagePreviewComponent, obj);
        //dialogRef.afterClosed().subscribe(result => {


        //});
    }

    downloadAttachment(p1: any, p2: any, p3: any) { }


    postBody: any = "";
    shareBtn: string = "POST";
    DisabledShareBtn: boolean = false;

    ShareMenuItems: any[] = [
        {
            title: "anyone",
            description: "anyone on mygistec",
            iconCSS: "fa fa-globe",
            code: "public"
        },
        {
            title: "connections",
            description: "your connections on mygistec",
            iconCSS: "fa fa-users",
            code: "connections"
        },
        {
            title: "gistec team",
            description: "all gistec team on mygistec",
            iconCSS: "fa fa-user",
            code: "gistec"
        }
    ];

    SelectedShareMenuItem = this.ShareMenuItems[0];

    SubmitShareMenuItem(item: any) {
        this.SelectedShareMenuItem = item;
    }

    SelectedShareWithId: string = "0";
    sendPost() {

        if (this.postBody != "") {

            this.shareBtn = "POSTING...";
            this.DisabledShareBtn = true;
            var postConnections = [];

            //for (var i = 0; i < this.ShareAllowedConnections.length; i++) {
            //  postConnections.push({
            //    'PortalUserId': this.ShareAllowedConnections[i].id,
            //    'isAllow': this.ShareAllowedConnections[i].allow
            //  })
            //}

            let postData: any = {
                post: {},
                connection: [],
                media: []
            };

            postData.post.body = this.postBody;
            postData.post.FromPortalUser_Id = this.authentication._authentication.id;

            if (this.SelectedShareWithId != "0")
                postData.post.ToPortalUser_Id = this.SelectedShareWithId;

            postData.post.privacy = this.SelectedShareMenuItem.code;
            postData.post.hasLink = false;
            postData.post.link = "";
            postData.post.relatedTo = this.relatedTo;
            postData.post.relatedId = this.relatedId;
            postData.connection = [];
            //postData.media = this.postMedia;

            //postData.containAttachment = this.postAttachment.containAttachment;
            //postData.attFilename = this.postAttachment.attFilename;
            //postData.attContentType = this.postAttachment.attContentType;
            //postData.attContent = this.postAttachment.attContent;

            this.postsService.addToUserPost(postData).subscribe(
                (res: any) => {
                    if (res.success) {
                        this.shareBtn = "POST";
                        this.DisabledShareBtn = false;
                        this.postBody = "";
                        //this.postLink = "";
                        //if (this.hasLink)
                        //  this.toggleLinkView();
                        //this.SelectedShareWithId = "0";
                        //this.ShareAllowedConnections = [];
                        //this.postMedia = [];


                        if (res.data != null) {
                            res.data.createdDate = new Date(res.data.createdDate);
                            res.data.postRepliesCollapsed = true;
                            res.data.postContactLogo = res.data.fromPortalUser.contactLogo;
                            res.data.postReplies = []
                            res.data.commentsSummary = "View all comments (" + 0 + ")";
                            res.data.shownComments = 0;
                            res.data.body = this.sanitizer.bypassSecurityTrustHtml(res.data.body);
                            this.posts.unshift(res.data);

                        }
                        this.modalService.dismissAll("submitted");
                    }

                },
                (err: any) => {
                    this.shareBtn = "POST STATUS";
                    this.DisabledShareBtn = false;
                    console.error("sendPost", err);
                }
            );

        }
        else {
            //this.ShowMessage('error', 'your post message is mandatory!', '')
        }
    }
}
